<script setup lang="ts">
import type { Address } from '~/types'

const props = defineProps<{
  context: {
    value: Address
    node: { input: (address?: Address) => void }
    placeholder?: string
    disabled?: boolean
  } & Record<string, any>
}>()

const { isEnabled } = useAddressAutoComplete()

// If address exist and (latitude or longitude) is missing we show basic input (address outside Koln), otherwise default is false
const showBasicInput = ref(props.context.value ? (!props.context.value.latitude || !props.context.value.longitude) : false)
</script>

<template>
  <FormKitCreateInputBaseAddressAutoComplete
    v-if="isEnabled && !showBasicInput"
    :address="context.value"
    :placeholder="context.placeholder"
    :disabled="context.disabled"
    @update:address="(address) => context.node.input(address)"
    @show-basic-input="showBasicInput = true"
  />
  <FormKitCreateInputBaseAddressBasicInput
    v-else
    :address="context.value"
    :disabled="context.disabled"
    :placeholder="context.placeholder"
    @update:address="(address) => context.node.input(address)"
    @show-autocomplete-input="showBasicInput = false"
  />
</template>
